import { useEffect, useState } from "react";

const CageQuestionnaire = () => {
    const [canSubmit, setCanSubmit] = useState<boolean>(false);
    const [result, setResult] = useState<number | null>(null);

    const [answers, setAnswers] = useState<{
        question1: number | null,
        question2: number | null,
        question3: number | null,
        question4: number | null,
    }>({
        question1: null,
        question2: null,
        question3: null,
        question4: null,
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, question: string) => {
        setAnswers((prevState) => ({ ...prevState, [question]: parseInt(e.target.value) }));
    }

    useEffect(() => {
        const allAnswersFilled = Object.values(answers).every((answer) => answer !== null);
        setCanSubmit(allAnswersFilled);
    }, [answers])

    const calculateScore = () => {
        const value = Object.values(answers).reduce((acc, val) => (acc ? acc : 0) + (val ? val : 0));

        if (value != null) {
            setResult(value);
        }
    }

    return (
        <>
            <div className="question1">
                <div className="flex items-center gap-x-4">
                    <div className="w-14 maxMd:w-8 text-center">
                        <p className="text-accordorange h3 tracking-[0.64px] font-semibold">1</p>
                    </div>
                    <p className="text-arcticMist h4 tracking-[0.48px] max-w-[calc(100%_-_80px)] maxMd:max-w-[calc(100%_-_48px)] w-full">Czy kiedykolwiek czułeś, że powinieneś ograniczyć picie?</p>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question1" id="question1yes" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question1')} value={1} />
                    <label htmlFor="question1yes" className="questionnaire-label">
                        Tak
                    </label>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question1" id="question1no" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question1')} value={0} />
                    <label htmlFor="question1no" className="questionnaire-label">
                        Nie
                    </label>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2px" className="my-8">
                    <pattern id="custom-border-pattern" width="16px" height="100%" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4px" height="100%" fill="#393ABF" />
                    </pattern>
                    <rect width="100%" height="2px" fill="url(#custom-border-pattern)" />
                </svg>
            </div>

            <div className="question2">
                <div className="flex items-center gap-x-4">
                    <div className="w-14 maxMd:w-8 text-center">
                        <p className="text-accordorange h3 tracking-[0.64px] font-semibold">2</p>
                    </div>
                    <p className="text-arcticMist h4 tracking-[0.48px] max-w-[calc(100%_-_80px)] maxMd:max-w-[calc(100%_-_48px)] w-full">Czy ludzie denerwowali cię, krytykując twoje picie?</p>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question2" id="question2yes" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question2')} value={1} />
                    <label htmlFor="question2yes" className="questionnaire-label">
                        Tak
                    </label>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question2" id="question2no" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question2')} value={0} />
                    <label htmlFor="question2no" className="questionnaire-label">
                        Nie
                    </label>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2px" className="my-8">
                    <pattern id="custom-border-pattern" width="16px" height="100%" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4px" height="100%" fill="#393ABF" />
                    </pattern>
                    <rect width="100%" height="2px" fill="url(#custom-border-pattern)" />
                </svg>
            </div>

            <div className="question3">
                <div className="flex items-center gap-x-4">
                    <div className="w-14 maxMd:w-8 text-center">
                        <p className="text-accordorange h3 tracking-[0.64px] font-semibold">3</p>
                    </div>
                    <p className="text-arcticMist h4 tracking-[0.48px] max-w-[calc(100%_-_80px)] maxMd:max-w-[calc(100%_-_48px)] w-full">Czy kiedykolwiek czułeś się źle lub winny z powodu picia?</p>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question3" id="question3yes" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question3')} value={1} />
                    <label htmlFor="question3yes" className="questionnaire-label">
                        Tak
                    </label>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question3" id="question3no" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question3')} value={0} />
                    <label htmlFor="question3no" className="questionnaire-label">
                        Nie
                    </label>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2px" className="my-8">
                    <pattern id="custom-border-pattern" width="16px" height="100%" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4px" height="100%" fill="#393ABF" />
                    </pattern>
                    <rect width="100%" height="2px" fill="url(#custom-border-pattern)" />
                </svg>
            </div>

            <div className="question4">
                <div className="flex items-center gap-x-4">
                    <div className="w-14 maxMd:w-8 text-center">
                        <p className="text-accordorange h3 tracking-[0.64px] font-semibold">4</p>
                    </div>
                    <p className="text-arcticMist h4 tracking-[0.48px] max-w-[calc(100%_-_80px)] maxMd:max-w-[calc(100%_-_48px)] w-full">Czy kiedykolwiek zdarzało Ci się, że pierwszą czynnością wykonaną rano po przebudzeniu było wypicie alkoholu dla uspokojenia lub "postawienia się na nogi"?</p>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question4" id="question4yes" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question4')} value={1} />
                    <label htmlFor="question4yes" className="questionnaire-label">
                        Tak
                    </label>
                </div>
                <div className="pl-18 maxMd:pl-12 flex items-center gap-x-6 py-1 mt-5 relative">
                    <input type="radio" name="question4" id="question4no" className="hidden questionnaire-input" onChange={(e) => handleInputChange(e, 'question4')} value={0} />
                    <label htmlFor="question4no" className="questionnaire-label">
                        Nie
                    </label>
                </div>
            </div>

            <button type="button" className="my-12 main-btn max-w-max mx-auto block" disabled={!canSubmit} onClick={calculateScore}>
                Sprawdź wynik
            </button>

            {result !== null &&
                <>
                    {result <= 1 ?
                        <div className="p-8 relative mb-12">
                            <div className="bg-emeraldPulse absolute left-0 top-0 h-full w-1"></div>
                            <p className="h4 text-arcticMist font-semibold tracking-[0.48px] mb-6">Obecnie nie ma oznak problemów</p>
                            <p className="text-arcticMist text-body tracking-[0.27px]">Wynik sugeruje, że nie ma obecnie oznak problemów związanych z używaniem alkoholu według kwestionariusza CAGE. Pamiętaj jednak, że ten wynik nie wyklucza możliwości wystąpienia problemów w przyszłości. Warto regularnie monitorować swoje nawyki związane z alkoholem i w razie jakichkolwiek obaw skonsultować się z lekarzem lub specjalistą. *</p>
                        </div>
                        :
                        <div className="p-8 relative mb-12">
                            <div className="bg-crimsonAlert absolute left-0 top-0 h-full w-1"></div>
                            <p className="h4 text-arcticMist font-semibold tracking-[0.48px] mb-6"> Istotne ryzyko problemów</p>
                            <p className="text-arcticMist text-body tracking-[0.27px]">Wynik wskazuje na istotne ryzyko problemów związanych z nadużywaniem alkoholu. Zaleca się skonsultowanie z lekarzem lub specjalistą w celu uzyskania profesjonalnej diagnozy i wsparcia. Im wyższy wynik, tym większe jest prawdopodobieństwo, że możesz potrzebować pomocy w zarządzaniu swoim zdrowiem w kontekście spożywania alkoholu. Pamiętaj, że wczesne podjęcie działań może pomóc w zapobieganiu poważniejszym problemom zdrowotnym. *</p>
                        </div>
                    }
                </>
            }

            <hr className="border-royalPeriwinkle mb-12" />

            <h2 className="text-arcticMist h5 font-semibold tracking-[0.36px]">Przypisy:</h2>

            <div className="flex mt-6 gap-x-4">
                <div className="w-8 text-center">
                    <p className="text-accordorange text-body tracking-[0.27px]">*</p>
                </div>
                <p className="text-arcticMist text-body tracking-[0.27px] max-w-[calc(100%_-_48px)] w-full">
                    Informacje zawarte w komunikatach po uzyskaniu punktów w kwestionariuszu CAGE zostały opracowane na podstawie ogólnie przyjętych interpretacji wyników tego narzędzia przesiewowego oraz literatury dotyczącej jego stosowania. Komunikaty te są zaprojektowane tak, aby były zgodne z kliniczną interpretacją wyników CAGE, ale jednocześnie dostosowane do formy informacji zwrotnej, którą można przekazać użytkownikom internetowym w celach edukacyjnych
                </p>
            </div>

            <div className="flex mt-6 gap-x-4">
                <div className="w-8 text-center">
                    <p className="text-accordorange text-body tracking-[0.27px]">1</p>
                </div>
                <p className="text-arcticMist text-body tracking-[0.27px] max-w-[calc(100%_-_48px)] w-full">
                    Ewing J.A., Detecting alcoholism. The CAGE questionnaire, „JAMA” 1984 Oct 12 252(14), s.1905-7.
                </p>
            </div>

            <div className="flex mt-6 gap-x-4">
                <div className="w-8 text-center">
                    <p className="text-accordorange text-body tracking-[0.27px]">2</p>
                </div>
                <p className="text-arcticMist text-body tracking-[0.27px] max-w-[calc(100%_-_48px)] w-full">
                    O'Brien, C. P."The CAGE Questionnaire for Alcohol Use: A Simple Tool to Identify Problems." The New England Journal of Medicine, 2008, 358(2), 112-120.
                </p>
            </div>

            <div className="flex mt-6 gap-x-4 maxMd:mb-16">
                <div className="w-8 text-center">
                    <p className="text-accordorange text-body tracking-[0.27px]">3</p>
                </div>
                <p className="text-arcticMist text-body tracking-[0.27px] max-w-[calc(100%_-_48px)] w-full">
                    Bernadt M.W., Mumford J., Taylor C., et al., Comparison of questionnaire and laboratory tests in the detection of excessive drinking and alcoholism, „Lancet” 1982 Feb 6 1(8267), s.325-8. Occupational Medicine 2014;64:473–474 doi:10.1093/occmed/kqu058
                </p>
            </div>
        </>
    )
}

export default CageQuestionnaire;